import { formatEventEntry } from "../../../domain/managedEvent";

const toManagedEvent = (row) => ({
  eventTitle: row.event_title,
  eventType: row.event_type,
  dateType: row.date_type,
  nextEventTime: row.next_event_time,
  eventStartDate: row.event_start_date,
  eventEndDate: row.event_end_date,
  timeZone: row.time_zone,
  timeZoneAbbr: row.time_zone_abbr,
  hasTime: Boolean(row.has_time),
});

const toEventEntry = (row) => formatEventEntry(toManagedEvent(row));

const END_MONTH = new Intl.DateTimeFormat("en-US", {
  month: "short",
  timeZone: "UTC",
});

const rangeEnd = ({ event_end_date: end }) => {
  const date = new Date(`${end}T00:00:00.000Z`);

  return ` – ${END_MONTH.format(date)} ${date.getUTCDate()}`;
};

const nextBatchSummary = (row) => {
  if (!row) return "No batches scheduled";

  const { month, day } = toEventEntry(row);
  const end =
    row.date_type === "Range" && row.event_end_date ? rangeEnd(row) : "";

  return `Next batch · ${month} ${day}${end}`;
};

export { nextBatchSummary, toEventEntry };
